import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ScrollLogo = () => {
  const containerRef = useRef(null);
  const badgeRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const badge = badgeRef.current;
    if (!container || !badge) return;

    const ctx = gsap.context(() => {
      const getStartLeft = () => {
        return window.innerWidth > 900 ? (window.innerWidth - 900) / 2 + 24 : 24;
      };

      const getTargetX = () => {
        const startX = getStartLeft();
        const endX = window.innerWidth - 76 - 24; // accommodates 76px badge width
        return endX - startX;
      };

      gsap.set(container, {
        x: 0,
        y: 0,
        left: () => `${getStartLeft()}px`,
        top: 14,
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: document.body,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 1.2,
          invalidateOnRefresh: true,
        },
      });

      // Fly across header to right side
      tl.to(
        container,
        {
          x: () => getTargetX(),
          y: 76,
          scale: 0.92,
          duration: 2,
          ease: 'power2.inOut',
        },
        0
      );

      // Glide down along the right side to footer
      tl.to(
        container,
        {
          y: () => window.innerHeight - 170,
          scale: 0.88,
          duration: 8,
          ease: 'none',
        },
        2
      );

      // Dynamic tilt on velocity
      ScrollTrigger.create({
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const velocity = self.getVelocity();
          const rotation = Math.max(Math.min(velocity / 260, 12), -12);
          gsap.to(badge, {
            rotation: rotation,
            duration: 0.35,
            ease: 'power2.out',
          });
        },
      });
    });

    return () => ctx.revert();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <aside
      className="scroll-logo-track"
      ref={containerRef}
      aria-label="Scroll progress watermark"
    >
      <button
        type="button"
        className="scroll-logo__btn"
        ref={badgeRef}
        onClick={scrollToTop}
        title="Return to top"
      >
        <div className="scroll-logo__halo" aria-hidden="true" />
        
        {/* Camera Icon */}
        <div className="scroll-logo__img-box">
          <img
            src="/assets/favicon.svg"
            alt="Shamoka Photography Mark"
            className="scroll-logo__img"
          />
        </div>

        {/* Stacked Underneath Text */}
        <div className="scroll-logo__text-box">
        </div>
      </button>
    </aside>
  );
};

export default ScrollLogo;